// import React from 'react';
// import { FaCheckCircle } from "react-icons/fa";
// import '../styles/whoweare.scss';

// const BenefitItem = ({ text }) => (
//   <li className="benefit-item">
//     <div className="check-circle">
//       <FaCheckCircle />
//     </div>
//     <span>{text}</span>
//   </li>
// );

// const WhoWeAre = () => (
//   <section className="artiza-identity-section">
//     <div className="identity-background-shape"></div>

//     <div className="identity-container">
//       {/* WHO WE ARE */}
//       <div className="identity-mission">
//         <p className="overline-text">WHO WE ARE</p>
//         <h2 className="mission-heading">Artiza: Empowering Kenya’s Makers.</h2>
//         <p className="mission-text">
//           <strong>We are a digital platform that connects, dignifies, and celebrates Kenya’s artisans.</strong> 
//           From carpenters to electricians, we bridge skilled makers with clients through technology, trust, 
//           and storytelling — redefining how craftsmanship is experienced and valued.
//         </p>
//         {/* <a href="/about" className="learn-more-link">Learn More About Our Mission →</a> */}
//       </div>

//       {/* WHAT WE DO */}
//       <div className="identity-services">
//         <p className="overline-text">WHAT WE DO</p>
//         <ul className="benefit-list">
//           <BenefitItem text="Provide verified artisan profiles with reviews, photos, and skills." />
//           <BenefitItem text="Connect homeowners and developers to trusted local talent." />
//           <BenefitItem text="Use AI for smart matching and AR for real-time design visualization." />
//           <BenefitItem text="Ensure fair pay, transparency, and quality at every step." />
//         </ul>
//         <a href="/login" className="cta-button">Hire an Artisan Today</a>
//       </div>
//     </div>
//   </section>
// );

// export default WhoWeAre;


// src/components/WhoWeAre.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import '../styles/whoweare.scss';

const BENEFITS = [
  'Provide verified artisan profiles with reviews, photos, and skills.',
  'Connect homeowners and developers to trusted local talent.',
  'Use AI for smart matching and AR for real-time design visualization.',
  'Ensure fair pay, transparency, and quality at every step.',
];

const BenefitItem = ({ text, index }) => (
  <li className="benefit-item">
    <span className="benefit-index">{String(index + 1).padStart(2, '0')}</span>
    <span className="benefit-check">
      <FaCheckCircle />
    </span>
    <span className="benefit-text">{text}</span>
  </li>
);

const WhoWeAre = () => (
  <section className="artiza-identity-section" id="who-we-are">
    {/* Decorative background */}
    <div className="identity-background-shape" />
    <span className="identity-glow identity-glow-1" />
    <span className="identity-glow identity-glow-2" />

    <div className="identity-container">
      {/* ============================================
          LEFT — Who we are
         ============================================ */}
      <div className="identity-mission">
        <p className="overline-text">
          <span className="overline-dot" />
          Who we are
        </p>

        <h2 className="mission-heading">
          Artiza: empowering
          <br />
          Kenya's <em>makers</em>.
        </h2>

        <p className="mission-text">
          <strong>
            We are a digital platform that connects, dignifies, and celebrates
            Kenya's artisans.
          </strong>{' '}
          From carpenters to electricians, we bridge skilled makers with
          clients through technology, trust, and storytelling — redefining how
          craftsmanship is experienced and valued.
        </p>

        <div className="mission-meta">
          <div className="meta-item">
            <strong>47</strong>
            <span>Counties</span>
          </div>
          <div className="meta-item">
            <strong>1,200+</strong>
            <span>Artisans</span>
          </div>
          <div className="meta-item">
            <strong>4.8★</strong>
            <span>Avg rating</span>
          </div>
        </div>
      </div>

      {/* ============================================
          RIGHT — What we do
         ============================================ */}
      <div className="identity-services">
        <p className="overline-text">
          <span className="overline-dot" />
          What we do
        </p>

        <ul className="benefit-list">
          {BENEFITS.map((text, i) => (
            <BenefitItem key={i} text={text} index={i} />
          ))}
        </ul>

        <Link to="/login" className="cta-button">
          Hire an artisan today
          <FaArrowRight />
        </Link>
      </div>
    </div>
  </section>
);

export default WhoWeAre;